module.exports = __webpack_public_path__ + "static/media/gpvnl-wildcards-logo.33850f13.png";